import React from "react";
import { ButtonProps, ButtonVariant, ButtonSize } from "./Button.types";

const variants: Record<
  ButtonVariant,
  (
    size: ButtonSize,
    isDark: boolean,
    forceWhite?: boolean
  ) => React.CSSProperties
> = {
  default: () => ({
    backgroundColor: "#5876EE",
    color: "#FFFFFF",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  outline: (size, isDark) => ({
    backgroundColor: "transparent",
    color: isDark ? "#FFFFFF" : "#424242",
    border: `1px solid ${isDark ? "#424242" : "#E2E2E2"}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  subtle: () => ({
    backgroundColor: "transparent",
    color: "#5876EE",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  danger: () => ({
    backgroundColor: "#DC2626",
    color: "#FFFFFF",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  dangerIcon: () => ({
    backgroundColor: "#DC2626",
    color: "#FFFFFF",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  icon: (size) => ({
    backgroundColor: "#5876EE",
    color: "#FFFFFF",
    border: "none",
    width: size === "sm" ? "32px" : "40px",
    height: size === "sm" ? "32px" : "40px",
    padding: size === "sm" ? "6px" : "8px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  }),
  iconOutline: (size, isDark) => ({
    backgroundColor: isDark ? "transparent" : "#FFFFFF",
    color: isDark ? "#FFFFFF" : "#1D1B1D",
    border: `1px solid ${isDark ? "#FFFFFF" : "#E0E0E0"}`,
    width: size === "sm" ? "32px" : "40px",
    height: size === "sm" ? "32px" : "40px",
    padding: size === "sm" ? "6px" : "8px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  }),
  dangerOutline: () => ({
    backgroundColor: "transparent",
    color: "#DC2626",
    border: "1px solid #DC2626",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  showHistory: () => ({
    backgroundColor: "#BDC311",
    color: "#424242",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0%",
  }),
};

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "default",
  size = "default",
  style,
  icon,
  theme,
}) => {
  // Theme prop'u varsa onu kullan, yoksa localStorage'tan oku
  const currentTheme = theme || localStorage.getItem("theme") || "light";
  const isDark = currentTheme === "dark";

  const sizeStyle: React.CSSProperties =
    size === "sm"
      ? {
          height: "32px",
          padding: "4px 8px",
          fontSize: "12px",
          lineHeight: "18px",
        }
      : {
          height: "40px",
          padding: "8px 12px",
          fontSize: "14px",
          lineHeight: "24px",
        };

  const isShowHistoryVariant = variant === "showHistory";
  const fontStyle: React.CSSProperties = isShowHistoryVariant
    ? {
        fontFamily: "Inter",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0%",
      }
    : {};

  const baseStyle: React.CSSProperties = {
    ...sizeStyle,
    ...variants[variant](size, isDark),
    ...fontStyle,
    borderRadius: "4px",
    fontFamily: "Inter",
    fontWeight: 500,
    letterSpacing: "0px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    ...style, // Custom style prop'unu en sona ekledik
  };

  return (
    <button onClick={onClick} style={baseStyle}>
      {icon && (
        <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      )}
      {children}
    </button>
  );
};

export default Button;
